
import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import  {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import  {environment} from '../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {validateEmpty} from '../../../global/custom-validate';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {first} from 'rxjs/operators';
import {ThongBaoFile} from '../../../models/info/thongbaofile';
import {ThongBao} from '../../../models/info/thongbao';
import {language} from '../../../language/vn';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {EditThongBaoComponent} from './edit.component';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {ReadThongBaoComponent} from './read.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {FormatService} from '../../../service/format/service-format';
import {YKTongHopThongBaoComponent} from './tonghop.component';
import {DatePipe} from '@angular/common';


@Component({
  templateUrl: './thongbao.component.html',

})
export class ThongBaoComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId: number;
  public currentPage: number = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: ThongBao[];
  public submitValidate = false;
  public srChuDe: string = '';
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public nguoiNhapId: number = Sessioncommand.staffId;
  public staffId: number = -1;
  public permissionCNThongBao: boolean = false;
  public permissionAdmin: boolean = false;
  public permissionMain: boolean = false;
  public permissionRead: boolean = false;
  public dateCurrent: Date = new Date();
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  constructor(
    public thongBaoService: ThongBaoService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public commandUtil: CommandUtil,
    public navItemService: NavItemService,
    public datePipe: DatePipe,
    public formatService: FormatService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {

    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, "0018", true).subscribe(
      x => {
        this.permissionCNThongBao = x > 0 ? true : false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, "0019", true).subscribe(
      x => {
        this.permissionMain = x > 0 ? true : false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, "0020", true).subscribe(
      x => {
        this.permissionRead = x > 0 ? true : false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, "0001", true).subscribe(
      x => {
        this.permissionAdmin = x > 0 ? true : false;
        this.formatService.getCurrentDateVN().subscribe(x => this.commandUtil.getDate(x));
        this.search();
      }
    );


  }

  public ykienTH(id: number) {

    const modalEdit = this.bsModalService.show(YKTongHopThongBaoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKTongHopThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<YKTongHopThongBaoComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }

  public showConfirmationModal(id: number): void {

    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }

  get f() {
    return this.frmGroup.controls;
  }

  edit(id: number) {

    const modalEdit = this.bsModalService.show(EditThongBaoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<EditThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });
  }

  docThongBao(id: number, nguoiNhap: number) {
    if ((this.nguoiNhapId === nguoiNhap && this.permissionMain) || this.permissionCNThongBao || this.permissionAdmin || this.permissionRead) {
      const modalEdit = this.bsModalService.show(ReadThongBaoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<ReadThongBaoComponent>modalEdit.content).edit(
        id
      );
      (<ReadThongBaoComponent>modalEdit.content).onClose.subscribe(result => {

      });
    }
  }

  search()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.nguoiNhapId = this.permissionCNThongBao === true ? -1 : this.nguoiNhapId;
    this.thongBaoService.findAllByQLDatePaging(this.srChuDe,  this.nguoiNhapId, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.thongBaoService.getCountByQLDateKeyword(this.srChuDe,  this.nguoiNhapId, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.thongBaoService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.giaiQuyetSuVuStatus = 0;

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

